import { CountUp } from 'countup.js';
import Swiper, { Pagination } from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  // mobile menu
  const masthead = document.querySelector('.masthead');
  const hamburger = document.querySelector('.hamburger');

  document.querySelectorAll('.mobile-menu-toggle').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      masthead.classList.toggle('toggled');
      hamburger.classList.toggle('is-active');
    });
  });

  if (document.body.classList.contains('home')) {
    // testimonials slider
    new Swiper('.home-testimonials--main-slider', {
      modules: [Pagination],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
      },
    });

    // numbers countup
    const countups = [];
    document.querySelectorAll('.countup-number').forEach((el) => {
      const amount = el.dataset.amount;
      const countup = new CountUp(el, amount);
      countups.push(countup);
    });

    if (countups.length) {
      const target = document.querySelector('.home-numbers');
      const observer = new IntersectionObserver(handleIntersection);

      observer.observe(target);

      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            countups.forEach((c) => {
              c.start();
            });

            observer.unobserve(entry.target);
          }
        });
      }
    }
  } else if (document.body.classList.contains('page-template-template-about')) {
    // numbers countup
    const countups = [];
    document.querySelectorAll('.countup-number').forEach((el) => {
      const amount = el.dataset.amount;
      const countup = new CountUp(el, amount);
      countups.push(countup);
    });

    if (countups.length) {
      const target = document.querySelector('.page-about--numbers');
      const observer = new IntersectionObserver(handleIntersection);

      observer.observe(target);

      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            countups.forEach((c) => {
              c.start();
            });

            observer.unobserve(entry.target);
          }
        });
      }
    }
  }
});
